import React, { useEffect } from 'react';
import { Modal, ProgressBar } from 'utils/imports.utils';
import './save_project_progress_popup.component.scss';
import { useSetState } from 'utils/functions.utils';

interface ISaveProjectProgressPopupProps {
    isOpen: boolean;
    progress: number;
}

const SaveProjectProgressPopup = (props: ISaveProjectProgressPopupProps) => {
    const [state, setState] = useSetState({
        progressText: 'Compiling Target Image...',
    })

    useEffect(() => {
        if (props.progress > 75) {
            setState({progressText: 'Saving Project...'})
        }
    },[props.progress])

    return (
        <Modal isOpen={props.isOpen}>
            <div className="progress_popup">
                <div className="progress_popup_container">
                    <div className="progress_popup_bar_container">
                        <ProgressBar text={state.progressText} value={props.progress} max={100}/>
                    </div> 
                </div>
            </div>
        </Modal>
    )
}

export default SaveProjectProgressPopup;